<template>
  <div class="product-area">
    <secBanner :zhTitle="this.$route.meta.zhTitle" :enTitle="this.$route.meta.enTitle"></secBanner>
    <div class="warp">
      <div class="type-item" v-for="(item, index) in typeArr" :key="index">
        <router-link :to="{ path: '/productCenter', query: { typename: item.id } }" :class="curType.id === item.id ? 'cur' : ''">{{ item.name }}</router-link>
      </div>
    </div>
    <ul class="dis_flex flex_wrap">
      <li v-for="(item, index) in dataList" :key="index">
        <router-link :to="{ name: 'ProductDetail', params: { id: item.id } }">
          <div class="img"><img :src="item.product_img_pc[0]" :alt="item.product_name" /></div>
          <div class="text">
            <div class="title ellipsis">{{ item.product_name }}</div>
          </div>
        </router-link>
      </li>
    </ul>
    <div class="more" v-if="dataList.length >= limit"><span @click="moreData">查看更多</span></div>
  </div>
</template>
<script>
import secBanner from '@/components/assembly/sec-banner';
export default {
  data() {
    return {
      typeArr: [
        {
          id: 'all',
          name: '全部'
        }
      ],
      curType: 0,
      dataList: [],
      total: 0,
      page: 1,
      limit: 10,
      routepath: this.$route.path,
      metaInfoAttr: {}
    };
  },
  metaInfo() {
    return {
      title: this.metaInfoAttr.title,
      meta: [
        {
          name: 'keywords',
          content: this.metaInfoAttr.keywords
        },
        {
          name: 'description',
          content: this.metaInfoAttr.description
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.typename) {
        this.typeArr.forEach(element => {
          if (element.id === this.$route.query.typename) {
            this.curType = element;
          }
        });
        this.page = 1;
        this.getList(this.$route.query.typename);
      }
    }
  },
  mounted() {
    this.getType();
  },
  methods: {
    getType: function() {
      this.$https
        .fetchPost('/Product/product_class_list', {})
        .then(res => {
          // console.log(res.data, this.$route.query.typename)
          this.typeArr = this.typeArr.concat(res.data.data);
          // this.$router.push({ name: 'ProductCenter', query: { id: res.data.data[0].id } })
          if (this.$route.query.typename) {
            this.typeArr.forEach(element => {
              if (String(element.id) === String(this.$route.query.typename)) {
                // console.log(element.id, element.id === Number(this.$route.query.typename))
                this.curType = element;
              }
            });
          } else {
            this.curType = this.typeArr[0];
          }
          this.page = 1;
          this.getList(this.curType.id);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getList: function(typeid) {
      this.$https
        .fetchPost('/Product/product_info_list', {
          product_class_id: typeid === 'all' ? '' : typeid,
          page: this.page,
          limit: this.limit
        })
        .then(res => {
          // console.log(res.data)
          this.getSeo();
          if (this.page === 1) this.dataList = [];
          this.dataList = this.dataList.concat(res.data.data);
          this.total = res.data.count;
        })
        .catch(err => {
          console.log(err);
        });
    },
    moreData() {
      this.page++;
      this.getList(this.curType.id);
    },
    getSeo() {
      // console.log(this.curType.name);
      this.$https
        .fetchPost('/api/getseo', {
          name: this.curType.name
        })
        .then(res => {
          if(res.data.data)
          this.metaInfoAttr = res.data.data;
        });
    }
  },
  components: {
    secBanner
  }
};
</script>
<style lang="less" scoped>
.product-area {
  background: #ffffff;
  .warp {
    margin-bottom: 30px;
    overflow-x: auto;
    white-space: nowrap;
    .type-item {
      display: inline-block;
      position: relative;
      padding: 0 15px;
      font-family: PingFang-SC-Medium;
      font-size: 26px;
      font-weight: normal;
      letter-spacing: 0.7px;
      color: rgba(33, 33, 33, 1);
      a {
        padding: 18px 5px;
        display: inline-block;
        color: rgba(33, 33, 33, 1);
        &.cur {
          font-weight: bold;
        }
        position: relative;
        &.cur::after {
          position: absolute;
          left: 10%;
          bottom: 0;
          content: '';
          width: 80%;
          height: 6px;
          background-image: linear-gradient(90deg, rgba(1, 175, 170, 1) 0%, rgba(1, 175, 170, 0.2) 100%), linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));
          background-blend-mode: normal, normal;
        }
      }
    }
  }
  li {
    background-color: #ffffff;
    box-shadow: 0px 5px 5px 0px rgba(12, 3, 6, 0.05);
    border-radius: 6px;
    overflow: hidden;
    // width: 46.667%;
    width: 350px;
    margin: 0 16px 20px;

    &:nth-child(2n) {
      margin-left: 0;
    }
    .img {
      width: 350px;
      height: 350px;
      border-radius: 6px;
      overflow: hidden;
      background-color: #eeeeee;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      padding: 13px 15px;
      width: 360px;
      text-align: center;
      .title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #666666;
        margin-bottom: 10px;
      }
    }
  }
  .more {
    text-align: center;
    font-size: 28px;
    color: #666666;
    padding: 10px 0 30px;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCenter.vue